import React from 'react';
import Navbar from './Navbar';

const PublicLayout = ({ children }) => {
  return (
    <div className="public-layout">
      <Navbar />
      <main className="public-main">{children}</main>
    </div>
  );
};

export default PublicLayout;